/* ============================================================
   METALLBAU ODENTHAL — FRANZOESISCHER BALKON
   Alles, was nur fuer die Balkon-Konfiguratoren gilt.
   Angelegt 14.08.2026. v1.0.0

   WARUM EINE EIGENE DATEI (Stefans Entscheidung vom 14.08.2026)
   Die Shopify-API kennt kein teilweises Aendern: Jeder Schreibvorgang
   ersetzt die GANZE Datei. In einer Sammeldatei loescht damit jede
   Sitzung mit veralteter Basis alles Neuere — ohne Merge, ohne
   Warnung, ohne Fehlermeldung. custom.css hat so an EINEM Tag zweimal
   Abschnitte verloren, custom.js trug den Handlauf-Block bis zum
   13.08.2026 mit.
   Diese Datei ist EIGENSTAENDIG. Sie braucht custom.js nicht; die
   Reihenfolge in layout/theme.liquid dient nur der Lesbarkeit.

   WAS SIE HEUTE TUT
   Sie liefert die Kopfzeile des Maß-Schritts. Beim Balkon ist "Maße"
   auf onlyX gestellt — es gibt nur EIN Maßfeld (Befestigungsabstand).
   Die Hoehe ist eine eigene Kacheloption "Höhe" (950/1000/1050/1100)
   in derselben Gruppe Schritt_Masse. Die Schrittfuehrung in custom.js
   sucht fuer die Kopfzeile ausschliesslich nach Maßfeldern und findet
   die Hoehe deshalb nie: In der Kopfzeile stand "B×H = 2000 mm",
   waehrend darunter "Höhe: 1000 mm" ausgewaehlt war. Von Stefan am
   14.08.2026 im Screenshot markiert.

   ⚠️ DER RADIO-WERT IST DIE QUELLE, NICHT DER TEXT.
   Am 14.08.2026 am lebenden Objekt gemessen: die Hoehen-Kachel hat
   WEDER .cl-po--swatch-text NOCH .visually-hidden — anders als die
   Kacheln, auf die sich custom.js sonst stuetzt. Der Text "1000 mm"
   steht nackt im .cl-po--swatch-button:

     <label class="cl-po--swatch-item grow">
       <input type="radio" name="properties[Höhe]" value="1000">
       <div class="cl-po--swatch cl-po--swatch-button …">1000 mm</div>
     </label>

   Ein erster Versuch ueber die beiden Klassen lieferte deshalb nichts.
   Das value="1000" ist eindeutig und formatunabhaengig. Der Textzweig
   bleibt als Rueckfall, falls ein Wert einmal keine Zahl traegt.

   ⚠️ NUR DIE ZIFFER wird uebernommen — die Kachel heisst "1000 mm";
   ohne das stuende "2000 mm × 1000 mm" in der Kopfzeile.

   ⚠️ DER SCHLUESSEL IST DIE CONFIG-UUID. Steht eine Config nicht in
   CONFIGS, passiert nichts — Fenstergitter, Stange und Handlauf
   bleiben unberuehrt. Genau dieselbe Bauart wie assets/handlauf.js.

   VERTRAG MIT custom.js
   window.MO_MASS_ZUSATZ(knoten, xWert) → Text oder null.
   custom.js ruft das in wertVon() auf, wenn nur EIN Maßfeld sichtbar
   ist, und faengt Fehler ab. Eine defekte Gruppendatei kann die
   Schrittfuehrung der anderen Gruppen also nicht anhalten.

   RUECKBAU: diese Datei loeschen und die Zeile in layout/theme.liquid
   entfernen. Die Kopfzeile faellt dann auf "B×H = 2000 mm" zurueck.
   ============================================================ */
(function () {
  'use strict';

  /* Configs, fuer die diese Datei zustaendig ist.
     clzcvcioym0b = "Französische Balkone version 3.0", LIVE auf den drei
     Verkaufsprodukten — nicht herausnehmen.
     cl5mcchywldt = "Französische Balkone version 3.1", seit 17.08.2026 der
     Arbeitsstand am Produkt franzosischer-balkon-02-verzinkt-test. Angelegt
     als eigene Config, KEINE Umbenennung von 3.0 — beide laufen parallel,
     dieselbe Bauart wie Fenstergitter 3.1/3.2.
     cl4bhjn8giur = "Französische Balkone 1.1", laeuft auf den drei echten
     Produkten weiter — sie hat KEINE getrennte Hoehe und faellt hier
     ohnehin durch, steht aber bewusst nicht drin, damit niemand denkt,
     sie sei vergessen worden. */
  var CONFIGS = {
    clzcvcioym0b: { hoeheOption: 'Höhe' },
    cl5mcchywldt: { hoeheOption: 'Höhe' }
  };

  function configVon(knoten) {
    var wrapper = knoten.closest('.cl-po--wrapper') || knoten.closest('[id^="cl"]');
    var id = wrapper && wrapper.id;
    return id && CONFIGS[id] ? CONFIGS[id] : null;
  }

  /* Gibt "2000 × 1000 mm" zurueck — oder null, wenn diese Datei fuer
     die Config nicht zustaendig ist oder keine Hoehe gewaehlt wurde. */
  window.MO_MASS_ZUSATZ = function (knoten, xWert) {
    if (!xWert) return null;
    var cfg = configVon(knoten);
    if (!cfg) return null;

    var opt = knoten.querySelector('.cl-po--option[data-option="' + cfg.hoeheOption + '"]');
    var inp = opt && opt.querySelector('.cl-po--swatch-item input:checked');
    if (!inp) return null;

    var roh = inp.value;
    if (!/\d/.test(roh)) {
      var item = inp.closest('.cl-po--swatch-item');
      roh = item ? item.textContent : '';
    }
    var zahl = (String(roh).match(/\d+/) || [])[0];
    return zahl ? xWert + ' × ' + zahl + ' mm' : null;
  };
})();
